import { HEADER_TRANSLATION_KEY } from '../constants';

export default {
  pt: {
    [HEADER_TRANSLATION_KEY]: {
      HEADER_ID_3_NAME: 'Recursos',
      HEADER_ID_3_ITEM_1_NAME: 'Blog',
      HEADER_ID_3_ITEM_1_DESCRIPTION:
        'Conteúdo relevante para a sua aprendizagem.',
      HEADER_ID_3_ITEM_2_NAME: 'Downloadable',
      HEADER_ID_3_ITEM_2_DESCRIPTION:
        'Ebooks, ferramentas, casos principais e mais.',

      HEADER_CALL_BUTTON: 'Ligue para nós',
      HEADER_FREE_TRIAL_BUTTON: 'Agende uma demonstração',
      HEADER_FORM_PHONE_LABEL: 'Número de telefone',
      HEADER_FORM_PHONE_ERROR: 'Digite um número válido',
      HEADER_FORM_PHONE_BUTTON: 'Contato',

      HEADER_CONTACT_DIALOG_TITLE:
        'Entre em contato com nossa equipe \n de especialistas',
      HEADER_CONTACT_DIALOG_DESCRIPTION:
        'Estamos disponíveis de segunda a sexta, das 9h às 18h (PET)',

      HEADER_CONFIRMATION_DIALOG_TITLE:
        'Muito obrigado por \n registrar seus dados',
      HEADER_CONFIRMATION_DIALOG_DESCRIPTION:
        'Entraremos em contato em breve \n para que você possa viver esta experiência.',
      HEADER_CONFIRMATION_DIALOG_BUTTON: 'Concluir',

      CLE_CTA: 'Conoce más',
      CLE_TITLE: 'Ecosistema de Desarrollo de Personas',
      CLE_DESCRIPTION:
        'Antes de elegir un programa de training para tu equipo, asegúrate de que podrás contar con las estadísticas necesarias para saber el impacto que generará.',
    },
  },
};
